import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ListItem } from '../../core/models/list-item';
import { Response, Http, ResponseContentType, RequestOptionsArgs, RequestOptions, Headers } from '@angular/http';
import { SearchCriteria } from '../models/search-criteria';
import { SearchResult } from '../models/search-result';
import { CoordinateList } from '../models/coordinate-list';

@Injectable()
export class SiteService {

  constructor(private http: Http,
              @Inject('ApplicationConfig') private config: any) { }

    getSites(): Observable<ListItem[]> {
      return this.http.get(this.config.apiEndpoint + '/api/irarsites/sites')
        .map((res: Response) => res.json())
        .catch((error: any) => Observable.throw(error.json() || 'Server error'));
    }

    getFarms(): Observable<ListItem[]> {
      return this.http.get(this.config.apiEndpoint + '/api/irarsites/farms/')
        .map((res: Response) => res.json())
        .catch((error: any) => Observable.throw(error.json() || 'Server error'));
    }

    getAuthors(): Observable<string[]> {
      return this.http.get(this.config.apiEndpoint + '/api/irarsites/authors/')
        .map((res: Response) => res.json())
        .catch((error: any) => Observable.throw(error.json() || 'Server error'));
    }

    search(criteria: SearchCriteria): Observable<SearchResult[]> {
      const headers = new Headers({'content-type': 'application/json'});
      const options: RequestOptions = new RequestOptions({headers: headers});
      return this.http.post(this.config.apiEndpoint + '/api/irarsites/search', criteria, options)
        .map((res: Response) => res.json())
        .catch((error: any) => Observable.throw(error.json() || 'Server error'));
    }

    download(id: number): Observable<ArrayBuffer> {
      return this.http.get(this.config.apiEndpoint + '/api/irarsites/download?id=' + id, { responseType: ResponseContentType.ArrayBuffer})
        .map((response: any) => [response['_body']])
        .catch((error: any) => Observable.throw(error.json() || 'Server error'));
    }

    getFarmCoordinates(): Observable<CoordinateList[]> {
      return this.http.get('./data/farms.json')
        .map((response: any) => response.json())
        .catch((error: any) => Observable.throw(error.json() || 'Server error'));
    }

    getAocCoordinates(): Observable<CoordinateList[]> {
      return this.http.get('./data/aoc.json')
        .map((response: any) => response.json())
        .catch((error: any) => Observable.throw(error.json() || 'Server error'));
    }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/services/site.ts